import "@fontsource/assistant/400.css";
import "@fontsource/assistant/600.css";
import "@fontsource/assistant/700.css";
import "@fontsource/outfit/600.css";
import "./estilos/global.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { almacenDeSesion, crearCognito } from "@/features/sesion";
import { leerEntorno } from "@/shared/config/entorno";
import { Aplicacion, type Configuracion } from "./Aplicacion";

async function configuracion(): Promise<Configuracion> {
  const entorno = leerEntorno(import.meta.env);
  // La comparación con la variable literal deja la demostración fuera del build real (código muerto).
  if (import.meta.env.VITE_DEMO === "true") {
    const [{ crearIdentidadDemo }, { crearServidorDemo }] = await Promise.all([
      import("@/demo/identidad"),
      import("@/demo/servidor"),
    ]);
    return { demo: true, apiUrl: "https://demo.invalid", identidad: crearIdentidadDemo(), fetch: crearServidorDemo() };
  }
  return {
    demo: false,
    apiUrl: entorno.apiUrl,
    identidad: crearCognito(
      { ...entorno.cognito, origen: window.location.origin },
      {
        fetch: (...a) => globalThis.fetch(...a),
        almacen: almacenDeSesion(),
        ir: (url) => {
          window.location.assign(url);
        },
        ahora: Date.now,
      },
    ),
  };
}

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("Falta el elemento #raiz en index.html");

void configuracion().then((config) => {
  createRoot(raiz).render(
    <StrictMode>
      <Aplicacion config={config} />
    </StrictMode>,
  );
});
